<template>
  <slider-tournament />

  <the-nav />

  <div class="main-wrap" v-if="isLoading || !tournament">
    <object class="preloader-logo-site" type="image/svg+xml" data="/images/mln-logo-preloader-site.svg"></object>
  </div>
  <div class="main-wrap" v-else>
    <div class="tournament-wrap">
      <div class="tournament-title-fl">
        <div class="tournament-title">
          <img src="/images/summer-games.svg" alt="" />
          <span>Турнир {{ tournament.title }}</span>
          <div class="tournament-title-win">
            Фонд <i>{{ tournament.prize }}</i>
          </div>
        </div>

        <div class="tournament-label">
          <span v-if="tournament.status === 'active'">Активный турнир</span>
          <span v-else-if="tournament.status === 'scheduled'">Запланированный турнир</span>
          <span v-else>Завершенный турнир</span>
        </div>

        <div class="tournament-link">
          <router-link :to="{ name: 'tournaments' }">Другие турниры</router-link>
        </div>
      </div>

      <div class="tournament-content">
        <div class="tournament-head">
          <div class="tournament-image">
            <img :src="tournament.img" :alt="tournament.title" />
          </div>
          <div class="tournament-timer">
            <div class="tournament-timer-cd">
              <template v-if="tournament.status === 'active'">
                <div class="tournament-timer-cd-1">До конца турнира осталось</div>
                <div class="tournament-timer-cd-2">
                  <vue-countdown
                    :time="getTime(new Date(tournament.date_end)) - new Date().getTime()"
                    :transform="transformSlotProps"
                    v-slot="{ days, hours, minutes, seconds }"
                  >
                    <div class="is-countdown">
                      <span class="countdown-row countdown-show4">
                        <span class="countdown-section green" v-if="days">
                          <span class="countdown-amount">{{ days }}</span>
                          <span class="countdown-period">ДД</span>
                        </span>
                        <span class="countdown-section ch">
                          <span class="countdown-amount">{{ hours }}</span>
                          <span class="countdown-period">ЧЧ</span>
                        </span>
                        <span class="countdown-section">
                          <span class="countdown-amount">{{ minutes }}</span>
                          <span class="countdown-period">ММ</span>
                        </span>
                        <span class="countdown-section">
                          <span class="countdown-amount">{{ seconds }}</span>
                          <span class="countdown-period">СС</span>
                        </span>
                      </span>
                    </div>
                  </vue-countdown>
                </div>
              </template>
              <template v-else-if="tournament.status === 'scheduled'">
                <div class="tournament-timer-cd-1">До начала турнира осталось</div>
                <div class="tournament-timer-cd-2">
                  <vue-countdown
                    :time="getTime(new Date(tournament.date_start)) - new Date().getTime()"
                    :transform="transformSlotProps"
                    v-slot="{ days, hours, minutes, seconds }"
                  >
                    <div class="is-countdown">
                      <span class="countdown-row countdown-show4">
                        <span class="countdown-section green" v-if="days">
                          <span class="countdown-amount">{{ days }}</span>
                          <span class="countdown-period">ДД</span>
                        </span>
                        <span class="countdown-section ch">
                          <span class="countdown-amount">{{ hours }}</span>
                          <span class="countdown-period">ЧЧ</span>
                        </span>
                        <span class="countdown-section">
                          <span class="countdown-amount">{{ minutes }}</span>
                          <span class="countdown-period">ММ</span>
                        </span>
                        <span class="countdown-section">
                          <span class="countdown-amount">{{ seconds }}</span>
                          <span class="countdown-period">СС</span>
                        </span>
                      </span>
                    </div>
                  </vue-countdown>
                </div>
              </template>
              <template v-else>
                <div class="tournament-end">Турнир закончен</div>
              </template>

              <div class="tournament-timer-info">
                <div class="tournament-timer-info-line">
                  <i>Начало: </i>{{ format(new Date(tournament.date_start), 'dd.MM.yyyy HH:mm') }}
                </div>
                <div class="tournament-timer-info-line">
                  <i>Конец: </i>{{ format(new Date(tournament.date_end), 'dd.MM.yyyy HH:mm') }}
                </div>
              </div>
            </div>

            <div class="tournament-timer-gift">
              <div class="tournament-timer-cd-1">Призовой фонд</div>
              <div class="tournament-timer-gift-price">{{ tournament.prize }}</div>
            </div>
          </div>
        </div>

        <div class="tournament-slots">
          <div class="tournament-slots-title">Участвующие автоматы</div>

          <slider-tournament-games :game_slugs="tournament.game_slugs" />
        </div>

        <div class="tournament-wins">
          <template v-if="tournament.status !== 'scheduled'">
            <div class="tournament-wins-title">Таблица призеров</div>
            <div class="tournament-wins-caption" v-if="isAuthenticated">
              Ваше место в турнире:
              <span>{{ tournament.user_position || (tournament?.winners?.length + 1).toString() + '+' }}</span>
            </div>
            <div class="tournament-wins-table-wrap" :class="{ active }">
              <div class="over-mob">
                <table class="tournament-wins-table">
                  <thead>
                    <tr>
                      <td>Место</td>
                      <td>
                        <img src="/images/tournament-wins-table2.svg" alt="" />
                        Логин
                      </td>
                      <td>
                        <img src="/images/tournament-wins-table3.svg" alt="" />
                        Баллы
                      </td>
                      <td>
                        <img src="/images/tournament-wins-table4.svg" alt="" />
                        Приз
                      </td>
                    </tr>
                  </thead>
                  <tbody v-if="tournament?.winners?.length">
                    <tr
                      v-for="(winner, index) in tournament?.winners"
                      :key="winner.id"
                      :class="
                        isAuthenticated && ((index + 1).toString() === tournament.user_position ? 'highlight' : '')
                      "
                    >
                      <td>
                        <span class="num">{{ index + 1 }}</span>
                      </td>
                      <td>
                        {{ winner.username }}
                        <!--                  <div class="tournament-wins-table-online"></div>-->
                      </td>
                      <td>{{ n(Math.round(winner.points)) }}</td>
                      <td>
                        <div class="tournaments-table-win-line-money" v-if="winner?.prize?.type === 'money'">
                          {{ winner?.prize?.prize }}
                        </div>
                        <div class="tournaments-table-win-line" v-else-if="winner?.prize?.type === 'prize'">
                          {{ winner?.prize?.prize }}
                        </div>
                        <div class="tournaments-table-win-line-fs" v-else-if="winner?.prize?.type === 'fs'">
                          {{ winner?.prize?.prize }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="4"><div>Нет победителей</div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="more" @click="active = !active">Показать все</div>
            </div>
          </template>

          <div class="tournament-wins-text">
            <div class="tournament-wins-text-title">Правила турнира</div>
            <div
              :class="`tournament-wins-text-content ${!this.showText ? 'tournament-wins-text-toggle' : ''}`"
              v-html="tournament.desc"
            />
            <div v-if="!this.showText" class="tournament-wins-text-toggle-btn" @click="this.showText = true">
              Показать весь текст
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFooter from '@/components/TheFooter'
import PlayLine from '@/components/PlayLine'
import TheHeader from '@/components/TheHeader'
import SliderTournament from '@/components/sliders/SliderTournament'
import SliderTournamentGames from '@/components/sliders/SliderTournamentGames'
import TheNav from '@/components/TheNav'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { FETCH_TOURNAMENT } from '@/store/actions.type.ts'
import { getTime, format } from 'date-fns'
import { transformSlotProps } from '@/utils'
import { mapGetters } from 'vuex'
import { useI18n } from 'vue-i18n'

export default {
  name: 'Tournament',
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['tournament', 'gameBySlug', 'isAuthenticated']),
  },
  components: { VueCountdown, SliderTournamentGames, TheNav, SliderTournament, TheHeader, PlayLine, TheFooter },
  data() {
    return {
      showText: false,
      active: false,
      isLoading: true,
    }
  },
  setup() {
    const { t, n } = useI18n()
    return { t, n, getTime, format, transformSlotProps }
  },
  mounted() {
    this.$store.dispatch(FETCH_TOURNAMENT, this.$route.params.slug).then(() => {
      this.isLoading = false
    })
  },
}
</script>

<style scoped>
.tournament-end {
  font-size: 34px;
}
.highlight {
  background-color: rgba(255, 0, 0, 0.5);
}
</style>
